import { Box, Button } from "@chakra-ui/react";
import {
  LinkAuthenticationElement,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import http from "../../../core/http";
import { trackEvent } from "../../../shared/analytics";
import {
  generateRedditEventId,
  getRedditClickId,
  trackRedditEvent,
} from "../../../shared/reddit";

const CheckoutForm = ({ user, priceId, plan, amount, currency, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    trackEvent("begin_checkout", {
      currency,
      value: amount,
      plan,
      store: "stripe",
      items: [{ item_id: priceId, item_name: "Redwing Premium" }],
    });
  }, [amount, currency, plan, priceId]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: "https://redwing.app/go-premium",
      },
      redirect: "if_required",
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
      trackEvent("purchase_failed", {
        plan,
        store: "stripe",
        stage: "payment_method",
        reason: result.error.code || result.error.type,
      });
      setIsLoading(false);
    } else {
      const redditEventId = generateRedditEventId();
      const response = await http.post("/v1/subscriptions", {
        paymentMethod: result.setupIntent.payment_method,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        priceId,
        redditClickId: getRedditClickId(),
        redditEventId,
      });

      if (response.error) {
        alert(`Failed ${response.error.message}`);
        trackEvent("purchase_failed", {
          plan,
          store: "stripe",
          stage: "subscription",
          reason: response.error.message,
        });
        setIsLoading(false);
        return;
      }

      setIsLoading(false);
      trackEvent(
        "purchase",
        {
          currency,
          value: amount,
          plan,
          store: "stripe",
          items: [{ item_id: priceId, item_name: "Redwing Premium" }],
        },
        {
          set: { is_premium: true, premium_type: "subscription" },
          setOnce: {
            first_purchase_platform: "web",
            first_purchase_date: new Date().toISOString(),
          },
        }
      );
      trackRedditEvent("Purchase", { value: amount, currency }, redditEventId);
      onSuccess(response.data.data);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box mb="2">
        <LinkAuthenticationElement
          options={{ defaultValues: { email: user.email } }}
        />
      </Box>
      <PaymentElement />
      <Button
        type="submit"
        mt="3"
        disabled={!stripe || isLoading}
        colorScheme="red"
        color="white"
        tabIndex={5}
      >
        Subscribe
      </Button>
    </form>
  );
};

export default CheckoutForm;
